export default __webpack_public_path__ + "static/media/success-form-submit.44d2421e.svg";